export default {
  root: ({ props }) => ({
    class: [
      // Flexbox
      'flex flex-col',

      // Position
      'relative',
      {
        'transition-none! transform-none! w-screen! h-screen! max-h-full! top-0! left-0!':
          props.position == 'full',
      },

      // Size
      {
        'h-full w-auto min-w-[320px] md:min-w-[600px] lg:max-w-[80%] 4xl:min-w-[800px]':
          props.position === 'left' || props.position === 'right',
        'h-auto w-full': props.position === 'top' || props.position === 'bottom',
      },

      // Shape
      'border-0 rounded-l-lg',
      'shadow-lg',

      // Colors
      'bg-white',
      'text-surface-700',

      // Transitions
      'transition-transform',
      'duration-300',

      // Misc
      'pointer-events-auto',
    ],
  }),
  header: ({ instance }) => ({
    class: [
      // Flexbox and Alignment
      'flex items-center shrink-0',
      { 'flex-col mr-auto w-full': instance.$attrs['navigatable'] },

      // Spacing
      'p-5',

      // Colors
      'text-txt-800',
      'border-b border-gray-200',
    ],
  }),
  title: {
    class: ['text-lg order-last truncate'],
  },
  icons: {
    class: ['flex items-center'],
  },
  closeButton: ({ instance }) => ({
    class: [
      'relative',

      // Flexbox and Alignment
      'flex items-center justify-center',

      // Size and Spacing
      'mr-2',
      'w-8 h-8',
      { 'mr-auto mb-2': instance.$attrs['navigatable'] },

      // Shape
      'border-0',
      'rounded-full',

      // Colors
      'text-surface-500',
      'bg-background-light-300',

      // Transitions
      'transition duration-200 ease-in-out',

      // States
      'hover:text-surface-700',
      'hover:bg-surface-100',
      'focus:outline-none focus:outline-offset-0 focus:ring focus:ring-inset',
      'focus:ring-0 focus:ring-primary-300/50',

      // Misc
      'overflow-hidden',
    ],
  }),
  closeButtonIcon: {
    class: [
      // Display
      '',

      // Size
      'w-3.5',
      'h-3.5',
    ],
  },
  content: ({ instance }) => ({
    class: [
      // Spacing and Size
      'pt-0',
      'h-full',
      'w-full',
      { 'p-0': instance.$attrs['no-spacing'] },
      { 'p-4': !instance.$attrs['no-spacing'] },

      // Growth and Overflow
      'grow',
      'overflow-y-auto',
    ],
  }),
  mask: ({ props }) => ({
    class: [
      // Transitions
      'transition-all',
      'duration-300',
      { 'p-5': !props.position == 'full' },

      // Background and Effects
      {
        'has-[.mask-active]:bg-transparent bg-[#0a020aa8]': props.modal,
        'has-[.mask-active]:backdrop-blur-none backdrop-blur-[2px]': props.modal,
      },
    ],
  }),
  transition: ({ props }) => {
    return props.position === 'top'
      ? {
          enterFromClass: 'translate-x-0 -translate-y-full translate-z-0 mask-active',
          leaveToClass: 'translate-x-0 -translate-y-full translate-z-0 mask-active',
        }
      : props.position === 'bottom'
        ? {
            enterFromClass: 'translate-x-0 translate-y-full translate-z-0 mask-active',
            leaveToClass: 'translate-x-0 translate-y-full translate-z-0 mask-active',
          }
        : props.position === 'left'
          ? {
              enterFromClass: '-translate-x-full translate-y-0 translate-z-0 mask-active',
              leaveToClass: '-translate-x-full translate-y-0 translate-z-0 mask-active',
            }
          : props.position === 'right'
            ? {
                enterFromClass: 'translate-x-full translate-y-0 translate-z-0 mask-active',
                leaveToClass: 'translate-x-full translate-y-0 translate-z-0 mask-active',
              }
            : {
                enterFromClass: 'opacity-0 mask-active',
                enterActiveClass: 'transition-opacity duration-400 ease-in',
                leaveActiveClass: 'transition-opacity duration-400 ease-in',
                leaveToClass: 'opacity-0 mask-active',
              };
  },
};
